// FlightCheck.jsx
import React from 'react';
import PropTypes from 'prop-types';

import {
  getIsOnAndroidWebview,
  getIsOnIOSWebview,
} from '../resource/getUserAgent.js';

const isInWebview = getIsOnAndroidWebview() || getIsOnIOSWebview();

class FlightCheck extends React.PureComponent {
  digestJwtToken = () => {
    const { meId, token, digestJwtToken } = this.props;
    if (meId || !token) {
      return;
    }
    return digestJwtToken({ token });
  };
  componentDidMount() {
    const { token, fetchFlightCheck } = this.props;
    fetchFlightCheck({});
    if (!isInWebview && token) {
      fetchFlightCheck({ token });
    }
    this.digestJwtToken();
  }
  componentDidUpdate({ token: prevToken }) {
    const { token, fetchFlightCheck } = this.props;
    if (token !== prevToken) {
      if (token && !isInWebview) {
        fetchFlightCheck({ token });
      }
      this.digestJwtToken();
    }
  }
  render() {
    return null;
  }
}

FlightCheck.propTypes = {
  token: PropTypes.string,
  meId: PropTypes.string,
  fetchFlightCheck: PropTypes.func.isRequired,
  digestJwtToken: PropTypes.func.isRequired,
};

FlightCheck.defaultProps = {
  token: '',
  meId: '',
};

export default FlightCheck;
